import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import UomService from '../services/UomService';
import { act } from 'react';
import { isEmpty } from 'lodash';

const initialState = {
    data: [],
    datas: [],
    formError: [],
    isSuccess: false,
    submitLoading: false,

    isOpenUomDialog: false,
};

export const fetchUomList = createAsyncThunk(
    'uom/fetchUomList',
    async (data) => {
        try {
            const resp = await UomService.FetchUomList(data);
            return resp;
        } catch (error) {
            return error.response.data;
        }
    },
);

export const createUom = createAsyncThunk('uom/createUom', async (data, { rejectWithValue }) => {
    try {
        const response = await UomService.CreateUom(data);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const updateUom = createAsyncThunk('uom/updateUom', async (data, { rejectWithValue }) => {
    try {
        const response = await UomService.UpdateUom(data);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const deleteUom = createAsyncThunk('uom/deleteUom', async (id, { rejectWithValue }) => {

    try {
        const response = await UomService.DeleteUom(id);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const getAllUom = createAsyncThunk('uom/all', async () => {
    try {
        const response = await UomService.AllUom();
        return response;
    } catch (error) {
        return error.response
    }
})

const uomSlice = createSlice({
    name: 'uom',
    initialState: initialState,
    reducers: {
        openUomDialog: (state, action) => {
            state.isOpenUomDialog = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUomList.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchUomList.fulfilled, (state, action) => {
                if (action.payload?.status === 200) {
                    state.datas = [...action.payload?.data.data];
                } else {
                    state.error = action.payload?.data.message;
                    toast.error(state.error);
                }
                state.loading = false;
            })
            .addCase(fetchUomList.rejected, (state, action) => {
                state.error = action.payload?.data;
                state.loading = false;
            })
            .addCase(createUom.pending, (state, action) => {
                state.submitLoading = true;
                state.formError = [];
                state.isSuccess = false;
            })
            .addCase(createUom.fulfilled, (state, action) => {
                state.datas.unshift(action.payload.data.data);
                state.submitLoading = false;
                state.isSuccess = true;
                toast.success(action.payload?.data.message);
            })
            .addCase(createUom.rejected, (state, action) => {
                state.submitLoading = false;
                state.isSuccess = false;
                const errors = action.payload?.data?.errors;
                if (isEmpty(errors)) {
                    toast.error(action.payload?.data?.message || 'Something went wrong');
                } else {
                    state.formError = errors;
                }
            })
            .addCase(updateUom.pending, (state, action) => {
                state.submitLoading = true;
                state.formError = [];
                state.isSuccess = false;
            })
            .addCase(updateUom.fulfilled, (state, action) => {
                const index = state.datas.findIndex((client) => client.id === action.payload.data.data.id);
                state.datas[index] = {
                    ...state[index],
                    ...action.payload.data.data,
                };
                state.isSuccess = true;
                state.submitLoading = false;
                toast.success(action.payload?.data.message);
            })
            .addCase(updateUom.rejected, (state, action) => {
                state.submitLoading = false;
                state.isSuccess = false;    
                const errors = action.payload?.data?.errors;
                if (isEmpty(errors)) {
                    toast.error(action.payload.data.message || 'Something went wrong');
                } else {
                    state.formError = errors;
                }
            })
            .addCase(deleteUom.pending, (state, action) => {
                state.submitLoading = true;
            })
            .addCase(deleteUom.fulfilled, (state, action) => {
                const deletedId = action.meta.arg;
                state.datas = state.datas.filter(item => item.id !== deletedId);
                state.submitLoading = false;
                state.isOpenUomDialog = false;
                toast.success(action.payload?.data.message);
            })
            .addCase(deleteUom.rejected, (state, action) => {
                state.submitLoading = false;
                toast.error(action?.payload?.data.message || 'Something went wrong');
            })
            .addCase(getAllUom.pending, (state,action) => {
                state.info = '';
                state.loading = true;
            })
            .addCase(getAllUom.fulfilled, (state, action) => {
                if(action.payload?.status == 200) {
                    state.datas = [...action.payload.data?.data];
                }else {
                    state.error = action.payload?.data?.message;
                    toast.error(state.error);
                }
                state.loading = false;
            })
            .addCase(getAllUom.rejected, (state, action) => {
                state.error = action.payload?.data.message;
                state.loading = false;
                toast.error(state.error);
            });
    },
});

const { reducer } = uomSlice;

export const { openUomDialog } = uomSlice.actions;

export const uomSelector = (state) => state?.uom;

export default reducer;
